import { createAction, props, union } from '@ngrx/store';
import { SharedDeliveryQueryI } from '../../api/shared-delivery/shared-delivery.query.int';
import { SharedDeliveryI } from '../../api/shared-delivery/shared-delivery.result.int';
import { SharedPageTypeEnum } from 'src/app/shared/navigation/page-type.enum';

/* eslint-disable max-len */

export const error = createAction('[Shared / Delivery] Error', props<{
  messageText: string;
  pageType: SharedPageTypeEnum;
}>());
export const reset = createAction('[Shared / Delivery] Reset', props<{
  pageType: SharedPageTypeEnum;
}>());
export const load = createAction('[Shared / Delivery] Get', props<{
  data: SharedDeliveryQueryI;
  pageType: SharedPageTypeEnum;
}>());
export const received = createAction('[Shared / Delivery] Received', props<{
  data: SharedDeliveryI;
  pageType: SharedPageTypeEnum;
}>());

const all = union({
  error,
  load,
  received,
  reset,
});
export type Actions = typeof all;
